import React from "react";
import { SellerType } from "../DefaultEproModel";
import RegisterLegalEntityScreen from "../../RegisterWolfScreen/RegisterLegalEntityScreen";
import RegisterIndividualScreen from "../../RegisterWolfScreen/RegisterIndividualScreen";
import { getSellerByEmpCode } from "../../../Services/e-pro/SupplierService";
import { SupplierDetail } from "../../../Services/e-pro/models/SupplierModel";

type Props = {
  permission?: string;
};
const CompanyDetials: React.FC<Props> = ({ permission }) => {
  const empCode = localStorage.getItem("employeeCode") || undefined;
  const [userProfile, setUserProfile] = React.useState<SupplierDetail>();
  const getUserProfile = async () => {
    if (empCode) {
      const response = await getSellerByEmpCode(empCode);
      if (response) setUserProfile(response.data);
    }
  };
  React.useEffect(() => {
    getUserProfile();
  }, []);

  return (
    <>
      {permission === SellerType.LegalEntity ? (
        <RegisterLegalEntityScreen sellerDetail={userProfile} />
      ) : (
        <RegisterIndividualScreen sellerDetail={userProfile} />
      )}
    </>
  );
};

export default CompanyDetials;
